<template>
  <div class="mt-7">
    <v-row no-gutters style="min-height:90vh" align="center" justify="center">
        <v-col
        cols="4"
        >
        <p class="text-center text-h4 font-weight-bold">Sign in or create an account</p>

     
          <v-card class="pa-5">
            
             <v-text-field
              outlined
              dense
              label="Username or email address"
              v-model="username"
             />
             <v-text-field
              outlined
              dense
              label="Password"
              v-model="password"
            />
            

          

          <v-checkbox label="Keep me signed in"></v-checkbox>
          <p class="mb-4"></p>
          <a href="#" class="green--text font-weight-bold">Forgot your username?</a> <br />
           <a href="#" class="green--text font-weight-bold">Forgot your password?</a>
          

              <p class="mb-4"></p>
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-btn @click="login" x-large rounded dark color="green lighten-1" style="text-transform:none"> Signin</v-btn>
            </v-row>
          </v-card>
          
          <p class="mb-7"></p>
          <p class="text-center"><v-btn  to="/admin/login" outlined>Login in as admin</v-btn></p>
          <p class="mb-7"></p>
          
          <p class="mb-7"></p>

        </v-col>

      </v-row>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      username:"",
      password:""
    }
  },
  methods:{
    login(){
      // alert("test")
      axios.get('https://zaastry-node.herokuapp.com/v1/user/customer').then(res=>{
        let cust=res.data
        console.log(res.data)
        for(var i=0;i<cust.length;i++){
          if(cust[i].username==this.username && cust[i].password==this.password){
            console.log("true")
            console.log(this.$store.state.customer)
            localStorage.setItem("customer",JSON.stringify(cust[i]))
            localStorage.setItem("auth",true)
            this.$store.commit("setAuth",true)
            this.$store.commit("setCustomer",cust[i])
            this.$router.go(-1)
          }
        }
      })
    }
  }

}
</script>

<style>

</style>